// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import { Component, ReactNode } from 'react';
import ErrorPage from '../pages/ErrorPage';

interface ErrorBoundaryState {
    error: boolean;
}

interface ErrorBoundaryProps {
    children: ReactNode;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { error: false };
    }

    componentDidCatch(): void {
        this.setState({
            error: true,
        });
    }

    render(): ReactNode {
        if (this.state.error) {
            return <ErrorPage />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
